import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE =
  "Calculatrice de charge ionique - Calcul de la charge ionique pour les éléments chimiques avec précision et facilité";
const DESCRIPTION =
  "Calculatrice de charge ionique - Calcul de la charge ionique pour les éléments chimiques avec précision et facilité. Calculateur de chimie en francais pour cours et TP, avec saisie simple, resultat rapide et interpretation claire.";
const KEYWORDS =
  "ion charge calculator, calculatrice chimie, formule de chimie, tp de chimie, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/ion-charge-calculator/";
const elements = [
  { symbol: "H", name: "Hydrogène", protons: 1 },
  { symbol: "He", name: "Hélium", protons: 2 },
  { symbol: "Li", name: "Lithium", protons: 3 },
  { symbol: "Be", name: "Béryllium", protons: 4 },
  { symbol: "B", name: "Bore", protons: 5 },
  { symbol: "C", name: "Carbone", protons: 6 },
  { symbol: "N", name: "Azote", protons: 7 },
  { symbol: "O", name: "Oxygène", protons: 8 },
  { symbol: "F", name: "Fluor", protons: 9 },
  { symbol: "Ne", name: "Néon", protons: 10 },
  { symbol: "Na", name: "Sodium", protons: 11 },
  { symbol: "Mg", name: "Magnésium", protons: 12 },
  { symbol: "Al", name: "Aluminium", protons: 13 },
  { symbol: "Si", name: "Silicium", protons: 14 },
  { symbol: "P", name: "Phosphore", protons: 15 },
  { symbol: "S", name: "Soufre", protons: 16 },
  { symbol: "Cl", name: "Chlore", protons: 17 },
  { symbol: "Ar", name: "Argon", protons: 18 },
  { symbol: "K", name: "Potassium", protons: 19 },
  { symbol: "Ca", name: "Calcium", protons: 20 },
];
function IonChargeCalculator() {
  const [selectedElement, setSelectedElement] = useState("Na");
  const [electrons, setElectrons] = useState("");
  const [charge, setCharge] = useState(null);
  const [error, setError] = useState("");
  const element = elements.find((e) => e.symbol === selectedElement);
  const handleCalculate = () => {
    if (!electrons) {
      setError("Veuillez entrer le nombre d'électrons");
      setCharge(null);
      return;
    }
    const electronsValue = parseInt(electrons, 10);
    if (isNaN(electronsValue) || electronsValue < 0) {
      setError("Veuillez entrer un nombre d'électrons valide et positif");
      setCharge(null);
      return;
    }
    const ionCharge = element.protons - electronsValue;
    setCharge(ionCharge);
    setError("");
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>Comment calculer la charge ionique</h2>
                <p>
                  La charge ionique d'un ion est calculée en soustrayant le nombre d'électrons du nombre de protons. Un atome neutre a le même nombre de protons et d'électrons, donc sa charge est zéro.
                </p>
                <p>
                  <strong>Formule : Charge d'ion = Nombre de protons - Nombre d'électrons</strong>
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="ltr">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Élément</label>
                      </b>
                      <select
                        value={selectedElement}
                        onChange={(e) => setSelectedElement(e.target.value)}
                        className="form-control"
                        style={{ width: "150px" }}
                      >
                        {elements.map((el) => (
                          <option key={el.symbol} value={el.symbol}>
                            {el.symbol} - {el.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Nombre de protons</label>
                      </b>
                      <input
                        type="number"
                        value={element.protons}
                        className="form-control"
                        style={{ width: "150px" }}
                        disabled
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Nombre d'électrons</label>
                      </b>
                      <input
                        type="number"
                        placeholder="Entrer le nombre d'électrons"
                        value={electrons}
                        onChange={(e) => setElectrons(e.target.value)}
                        className="form-control"
                        style={{ width: "150px" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Erreur : {error}
                      </p>
                    ) : (
                      charge !== null && (
                        <p className="p-3 mb-2 bg-success text-white">
                          Charge ionique : {charge > 0 ? "+" : ""}{charge}
                        </p>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">  <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <br />
    </div>
  );
}
export default IonChargeCalculator;
